/**
 * Router — Surface Layer (/01)
 *
 * Wraps the generated routeTree into a TanStack Router instance. The
 * router is consumed by main.tsx via <RouterProvider />.
 */

import { createRouter } from '@tanstack/react-router';
import { routeTree } from './routeTree.gen';
import { RouterPending, RouterError } from './shell/RouterFallbacks';

export const router = createRouter({
  routeTree,
  defaultPreload: 'intent',
  defaultPreloadStaleTime: 0,
  // Auth Flow v2: __root.beforeLoad is async (it can await the security gate). Without these,
  // a pending guard or a router-level error renders a BLANK/WHITE screen (REQ-001.83 /step-up bug).
  // These contained login-layout cards guarantee a visible, safe state on every route instead.
  defaultPendingComponent: RouterPending,
  defaultErrorComponent: RouterError,
  defaultPendingMs: 150,
});

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}
